import script from "./EditorNavigator.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorNavigator.vue?vue&type=script&setup=true&lang=js"

import "./EditorNavigator.vue?vue&type=style&index=0&id=4e43797a&lang=css"

const __exports__ = script;

export default __exports__